import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function LegalLayout({ title, overline, updated, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-14 lg:py-20">
        <nav className="text-xs font-body text-white/50 mb-8 flex items-center gap-1.5" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight size={12} />
          <span className="text-white/80">{title}</span>
        </nav>
        <div className="overline text-[#D96A1B] mb-3">{overline}</div>
        <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tighter leading-none mb-4">
          {title}
        </h1>
        <div className="text-xs font-body text-white/40 uppercase tracking-widest mb-10">
          Last updated: {updated}
        </div>
        <div className="prose-mileforge font-body text-white/75 leading-relaxed space-y-6">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-sm text-white/50">
            Questions? Reach us at{" "}
            <a href="mailto:hello@mileforge.in" className="text-[#D96A1B] hover:underline">hello@mileforge.in</a>
          </div>
          <Link to="/contact" className="btn-ghost inline-flex text-xs">Contact Us</Link>
        </div>
      </div>
    </div>
  );
}

export function LegalH2({ children }) {
  return (
    <h2 className="font-display text-xl sm:text-2xl uppercase tracking-tight text-white pt-4">
      {children}
    </h2>
  );
}

export function LegalP({ children }) {
  return <p className="text-white/75 leading-relaxed">{children}</p>;
}

export function LegalUL({ children }) {
  return <ul className="list-disc pl-6 space-y-2 text-white/75 marker:text-[#D96A1B]">{children}</ul>;
}
